export default {
    TOUR (state) {
        return state.instance
    },
}